import { Link } from 'react-router-dom'
import { Mail, Phone, MapPin } from 'lucide-react'
import { siteConfig } from '@/lib/utils'

export function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className="border-t border-border/50 bg-secondary/30">
      <div className="container py-12 grid gap-10 md:grid-cols-3">
        <div>
          <Link to="/" className="flex items-center gap-2">
            <img src="/brand/logo-horizontal.svg" alt="i3 Solutions" className="h-20 w-auto" />
          </Link>
          <p className="mt-4 text-sm text-muted-foreground max-w-sm">
            Encurtamos percursos, eliminamos etapas e impulsionamos a eficiência. Tecnologia
            que transforma negócios.
          </p>
        </div>

        <div>
          <h3 className="text-sm font-semibold mb-4">Navegação</h3>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/" className="hover:text-foreground">Home</Link></li>
            <li><Link to="/cases" className="hover:text-foreground">Cases</Link></li>
            <li><Link to="/contato" className="hover:text-foreground">Contato</Link></li>
            <li>
              <a
                href="https://status.i3solutions.tech"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-foreground"
              >
                Status
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold mb-4">Contato</h3>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-start gap-2">
              <Mail className="size-4 mt-0.5 text-primary shrink-0" />
              <a href={`mailto:${siteConfig.email}`} className="hover:text-foreground">
                {siteConfig.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Phone className="size-4 mt-0.5 text-primary shrink-0" />
              <a href={siteConfig.whatsapp} target="_blank" rel="noopener noreferrer" className="hover:text-foreground">
                {siteConfig.phone}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="size-4 mt-0.5 text-primary shrink-0" />
              <span>
                {siteConfig.address.street}, {siteConfig.address.neighborhood}
                <br />
                {siteConfig.address.city}/{siteConfig.address.state}
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border/50">
        <div className="container py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <span>© {year} i3 Solutions. Todos os direitos reservados.</span>
          <span>
            Hospedado com observabilidade self-hosted ·{' '}
            <a
              href="https://status.i3solutions.tech"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground"
            >
              status
            </a>
          </span>
        </div>
      </div>
    </footer>
  )
}
